var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"alert-box",class:("cheetah-alert-box cheetah-alert-box__" + (_vm.type || 'information'))},[_c('div',{staticClass:"cheetah-alert-box__content"},[(_vm.with_icon)?_c('font-awesome-icon',{attrs:{"icon":['fas', 'exclamation-circle']},on:{"click":_vm.close}}):_vm._e(),_vm._v(" "),_vm._t("content")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d52bb52","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/commons/AlertBoxNewComponent.vue
// module id = null
// module chunks = 